import { createReducer } from 'redux-create-reducer'
import * as ACT from 'actions/actionTypes'

const initialState = {
  pageTitle: '',
  notifications: null
}

const appReducer = createReducer(initialState, {
  [ACT.PUSH_NOTIFICATION](state, action) {
    return {
      ...state,
      notifications: {
        title: action.payload.title,
        message: action.payload.message,
        level: action.payload.level,
        position: action.payload.position || 'tr',
        autoDismiss:
          typeof action.payload.autoDismiss === 'number' ? action.payload.autoDismiss : 5,
        dismissible: action.payload.dismissible || 'both',
        uid: action.payload.uid || null,
        onRemove: action.payload.onRemove || null
      }
    }
  },
  [ACT.CLEAR_NOTIFICATION](state, action) {
    return {
      ...state,
      notifications: {
        clear: true,
        uid: action.payload.uid
      }
    }
  },
  [ACT.UPDATE_PAGE_TITLE](state, action) {
    return {
      ...state,
      pageTitle: {
        ...state.pageTitle,
        ...action.payload
      }
    }
  },
  [ACT.UPDATE_PAGE_DESCRIPTION](state, action) {
    return {
      ...state,
      pageDescription: action.payload.description
    }
  }
})

export default appReducer
